import { Outlet } from "react-router-dom";

import Navbar from "../components/Navbar";

function PublicLayout() {
  return (
    <>
      <div className="navbar-main">
        <Navbar />
      </div>

      <div className="land-section">
        <Outlet />
      </div>

      {/* Footer Component Here Later */}
    </>
  );
}

export default PublicLayout;